// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	background-color: #fff !important;
	overflow-x: hidden;
}

.btn_bus {
	background-color: #83A4CF !important;
}
.bus_filtr_btn .btn-primary {
	background-color: #83a4cf !important;
	border-color: #83a4cf !important;
}

/* .bus_filtr_btn .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target {
	background-color: #83a4cf !important;
	border-color: #83a4cf !important;
} */
/* .filter_bus_icon_f .btn:hover {
	color: #fff !important;
	background-color: #83a4cf96 !important;
	border-color: #83a4cf96 !important;
} */

/* .material-symbols-outlined{
	font-size: 14px !important;
} */
.btn-primary{
	background-color: #358696 !important;
	/* background-color: #83A4CF !important; */
    border-color: #358696 !important;
    /* border-color: #83A4CF !important; */
}
.rcaMainDiv .btn-outline-primary{
	color:#358696 ;
	/* color:#83A4CF ; */
	border-color:#358696;
	/* border-color:#83A4CF; */
}
.rcaMainDiv .btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	/* background-color:#83A4CF; */
	background-color:#358696;
	color:#fff;
}
.bg-white{
	background-color:#fff;
}
.rcaMainDiv{
	margin-top:80px;
}
.aisFilterDiv {
    background: #e7e7e7;
}
.aisTitleChart {
    font-size: 0.8em;
    color: #0E3157;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: left;
    background: #E0E0E0;
	border-radius: 5px 5px 0 0;
}
.aisChartbox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    color: #353535;
	min-height: 280px;
	border-radius: 5px;
}
.aisWd{
	min-height: 330px !important;
}
.aisChartHGT{
    padding: 10px;
}
.aisFilterForm > .form-label{
	font-size:0.825em;
}
.aisHeadfont{
	font-size:1.8rem;
}
.aistopRightDropMenu .dropdown-menu[data-bs-popper] {
    right:0 !important;
	left: auto;
}
.dropdownSelectBtnAIS{
	width: fit-content;
}

/*****************************  *******************************/


/*************************  *****************************/

/* media queries start here */

@media screen and (max-width: 720px) {

}

@media screen and (max-width: 480px) {

.aisHeadfont {
    font-size: 1rem;
}
}

.forDayError{
	margin-top: -12px !important;
}

.top-filterARAI {
	width: 100%;
	background: #fff;
	height: 37px;
	border: solid 1px #a5a5a5;
	border-radius: 3px;
	font-size: 14px;
	color: #353535;
	text-indent: 10px;
}

/* my rca css */
.rcaBoxes {
	background: #FFFFFF;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
	color: #353535;
	border-radius: 5px;
}

.padRLpointFifty{
	padding-right: 0.50rem;
	padding-left: 0.50rem;
}

.paginationRcaAce {
	/* margin-top: 5px; */
	margin-bottom: 5px;
	text-align: center;
	display: flex;
	/* Use flexbox to arrange buttons horizontally */
	justify-content: center;
	/* Center the buttons horizontally */
	align-items: center;
	/* Center the buttons vertically */
}

.paginationRcaAce button {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	/* Makes the button circular */
	margin: 2px;
	border: 1px solid #ccc;
	background-color: #fff;
	color: #32879c;
	/* color: #83A4CF; */
	font-size: 13px;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}

.paginationRcaAce button.active {
	background-color: #32879c;
	/* background-color: #83A4CF; */
	color: #fff;
	border-color: #32879c;
	/* border-color: #83A4CF; */
}

.css-1xc3v61-indicatorContainer{
	padding: 0px !important;
}

.css-dvua67-singleValue{
	padding-top: 13px;
}

/* .css-gay1qq-control .css-1hwfws3 .css-151xaom-placeholder{
	padding-top: 13px;
} */

.h1TogglerButtonAce {
	font-weight: Bold;
	margin-left:0.5rem;
	padding-top:0.5rem;
	font-size:2em;
	color:#32879c;
	/* color:#83A4CF; */
	border-color:#32879c;
	/* border-color:#83A4CF; */
	cursor: pointer;
}

.tempCla{
	padding: 0px 0px 2px 6px;
}

.tempClsMain{
	padding-right: 2px;
	margin-left: -8px;
}

.freezeTableHeader {
    background-color: rgb(53, 134, 150);
    color: rgb(255, 255, 255);
    position: sticky;
    top: 0;
    z-index: 0;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Rca_Ace/rcaaceCustom.css"],"names":[],"mappings":"AAAA;CACC,iCAAiC;CACjC,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;CACpC,gCAAgC;AACjC;;AAEA;;;;;;;;;GASG;AACH;;;;GAIG;;AAEH;;GAEG;AACH;CACC,oCAAoC;CACpC,0CAA0C;IACvC,gCAAgC;IAChC,sCAAsC;AAC1C;AACA;CACC,cAAc;CACd,oBAAoB;CACpB,oBAAoB;CACpB,0BAA0B;AAC3B;AACA;CACC,8BAA8B;CAC9B,wBAAwB;CACxB,UAAU;AACX;AACA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB,0BAA0B;AAC3B;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,cAAc;CACjB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,4BAA4B;AAC7B;AACA;IACI,aAAa;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;IACI,kBAAkB;CACrB,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;;AAEA,+DAA+D;;;AAG/D,yDAAyD;;AAEzD,6BAA6B;;AAE7B;;AAEA;;AAEA;;AAEA;IACI,eAAe;AACnB;AACA;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB;;AAEA,eAAe;AACf;CACC,mBAAmB;CACnB,wCAAwC;CACxC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,gDAAgD;CAChD,uBAAuB;CACvB,oCAAoC;CACpC,mBAAmB;CACnB,kCAAkC;AACnC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,8BAA8B;CAC9B,WAAW;CACX,sBAAsB;CACtB,sBAAsB;CACtB,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,eAAe;CACf,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,gEAAgE;AACjE;;AAEA;CACC,yBAAyB;CACzB,+BAA+B;CAC/B,WAAW;CACX,qBAAqB;CACrB,2BAA2B;AAC5B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;GAEG;;AAEH;CACC,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,oBAAoB;CACpB,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd","sourcesContent":["body {\n\tbackground-color: #fff !important;\n\toverflow-x: hidden;\n}\n\n.btn_bus {\n\tbackground-color: #83A4CF !important;\n}\n.bus_filtr_btn .btn-primary {\n\tbackground-color: #83a4cf !important;\n\tborder-color: #83a4cf !important;\n}\n\n/* .bus_filtr_btn .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target {\n\tbackground-color: #83a4cf !important;\n\tborder-color: #83a4cf !important;\n} */\n/* .filter_bus_icon_f .btn:hover {\n\tcolor: #fff !important;\n\tbackground-color: #83a4cf96 !important;\n\tborder-color: #83a4cf96 !important;\n} */\n\n/* .material-symbols-outlined{\n\tfont-size: 14px !important;\n} */\n.btn-primary{\n\tbackground-color: #358696 !important;\n\t/* background-color: #83A4CF !important; */\n    border-color: #358696 !important;\n    /* border-color: #83A4CF !important; */\n}\n.rcaMainDiv .btn-outline-primary{\n\tcolor:#358696 ;\n\t/* color:#83A4CF ; */\n\tborder-color:#358696;\n\t/* border-color:#83A4CF; */\n}\n.rcaMainDiv .btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\n\t/* background-color:#83A4CF; */\n\tbackground-color:#358696;\n\tcolor:#fff;\n}\n.bg-white{\n\tbackground-color:#fff;\n}\n.rcaMainDiv{\n\tmargin-top:80px;\n}\n.aisFilterDiv {\n    background: #e7e7e7;\n}\n.aisTitleChart {\n    font-size: 0.8em;\n    color: #0E3157;\n    font-weight: 500;\n    margin-bottom: 10px;\n    text-align: left;\n    background: #E0E0E0;\n\tborder-radius: 5px 5px 0 0;\n}\n.aisChartbox{\n\tbackground: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    color: #353535;\n\tmin-height: 280px;\n\tborder-radius: 5px;\n}\n.aisWd{\n\tmin-height: 330px !important;\n}\n.aisChartHGT{\n    padding: 10px;\n}\n.aisFilterForm > .form-label{\n\tfont-size:0.825em;\n}\n.aisHeadfont{\n\tfont-size:1.8rem;\n}\n.aistopRightDropMenu .dropdown-menu[data-bs-popper] {\n    right:0 !important;\n\tleft: auto;\n}\n.dropdownSelectBtnAIS{\n\twidth: fit-content;\n}\n\n/*****************************  *******************************/\n\n\n/*************************  *****************************/\n\n/* media queries start here */\n\n@media screen and (max-width: 720px) {\n\n}\n\n@media screen and (max-width: 480px) {\n\n.aisHeadfont {\n    font-size: 1rem;\n}\n}\n\n.forDayError{\n\tmargin-top: -12px !important;\n}\n\n.top-filterARAI {\n\twidth: 100%;\n\tbackground: #fff;\n\theight: 37px;\n\tborder: solid 1px #a5a5a5;\n\tborder-radius: 3px;\n\tfont-size: 14px;\n\tcolor: #353535;\n\ttext-indent: 10px;\n}\n\n/* my rca css */\n.rcaBoxes {\n\tbackground: #FFFFFF;\n\tbox-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n\tcolor: #353535;\n\tborder-radius: 5px;\n}\n\n.padRLpointFifty{\n\tpadding-right: 0.50rem;\n\tpadding-left: 0.50rem;\n}\n\n.paginationRcaAce {\n\t/* margin-top: 5px; */\n\tmargin-bottom: 5px;\n\ttext-align: center;\n\tdisplay: flex;\n\t/* Use flexbox to arrange buttons horizontally */\n\tjustify-content: center;\n\t/* Center the buttons horizontally */\n\talign-items: center;\n\t/* Center the buttons vertically */\n}\n\n.paginationRcaAce button {\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 50%;\n\t/* Makes the button circular */\n\tmargin: 2px;\n\tborder: 1px solid #ccc;\n\tbackground-color: #fff;\n\tcolor: #32879c;\n\t/* color: #83A4CF; */\n\tfont-size: 13px;\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttransition: background-color 0.3s, color 0.3s, border-color 0.3s;\n}\n\n.paginationRcaAce button.active {\n\tbackground-color: #32879c;\n\t/* background-color: #83A4CF; */\n\tcolor: #fff;\n\tborder-color: #32879c;\n\t/* border-color: #83A4CF; */\n}\n\n.css-1xc3v61-indicatorContainer{\n\tpadding: 0px !important;\n}\n\n.css-dvua67-singleValue{\n\tpadding-top: 13px;\n}\n\n/* .css-gay1qq-control .css-1hwfws3 .css-151xaom-placeholder{\n\tpadding-top: 13px;\n} */\n\n.h1TogglerButtonAce {\n\tfont-weight: Bold;\n\tmargin-left:0.5rem;\n\tpadding-top:0.5rem;\n\tfont-size:2em;\n\tcolor:#32879c;\n\t/* color:#83A4CF; */\n\tborder-color:#32879c;\n\t/* border-color:#83A4CF; */\n\tcursor: pointer;\n}\n\n.tempCla{\n\tpadding: 0px 0px 2px 6px;\n}\n\n.tempClsMain{\n\tpadding-right: 2px;\n\tmargin-left: -8px;\n}\n\n.freezeTableHeader {\n    background-color: rgb(53, 134, 150);\n    color: rgb(255, 255, 255);\n    position: sticky;\n    top: 0;\n    z-index: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
